import React, { useState, useCallback, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate, useLocation } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import { facilitiesHeadCells } from "../util/headcells-util";
import {
  fetchFacilitiesData,
  removeFacilityRecord,
  fetchFacilityById,
} from "../services/sendingFacilities-service";
import { fetchCodeSetTable } from "../services/referenceTable-service";
import { showPopupDetails } from "../util/common";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { SFTRB } from "../util/component-codes";
import Cookies from "js-cookie";

const Facilities = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleError = () => {
    let value = false;
    if (location?.state?.isAdded != null) {
      value = !location?.state?.isAdded;
    } else if (location?.state?.isUpdated != null) {
      value = !location?.state?.isUpdated;
    }
    return value;
  };

  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [alertMessage, setAlertMessage] = useState(location?.state?.message
    ? location?.state?.message : null);
    const [filter, setFilter] = useState(
      location?.state?.filter ? location?.state?.filter : {}
    );
  const [isAdded, setIsAdded] = useState(
    location?.state?.isAdded != null ? location?.state?.isAdded : false
  );
  const [isUpdated, setIsUpdated] = useState(
    location?.state?.isUpdated != null ? location?.state?.isUpdated : false
  );

  const [isError, setIsError] = useState(handleError());
  const [isDeleted, setIsDeleted] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [facilitiesData, setFacilitiesData] = useState(null);
  const [states, setStates] = useState([]);
  const [facilityDetails, setFacilityDetails] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [pageNo, setPageNo] = useState(location?.state?.pageNo ? location?.state?.pageNo : 0 );
  const [isFetchError, setIsFetchError] = useState(false);
  const [statesCheckedValues, setStatesCheckedValues] = useState(location?.state?.filter?.states ? location?.state?.filter?.states :[]);

  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleCloseDetailsModal = () => setShowDetailsModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const [user] = useContext(UserContext);

  const urlWithParams = (filter) => {
    let facilityName = filter?.searchNameText ? filter?.searchNameText : "";
    let facilityIdentifier = filter?.searchFacilityIdText
      ? filter?.searchFacilityIdText
      : "";
    let facilityCity = filter?.searchCityText ? filter?.searchCityText : "";
    let parentOrganizations = filter?.parentOrgText
      ? filter?.parentOrgText
      : "";
    let facilityType = [];
    let state = filter?.states?.length > 0 ? filter?.states : [];
    let dataType = [];

    let isActive = [];

    if (filter?.lab) {
      facilityType.push("Lab");
    }
    if (filter?.facility) {
      facilityType.push("Facility");
    }
    if (filter?.elr) {
      dataType.push("ELR");
    }
    if (filter?.ecr) {
      dataType.push("ECR");
    }
    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (facilityName !== "") {
      params += `&name=${facilityName}`;
    }
    if (facilityIdentifier !== "") {
      params += `&identifier=${facilityIdentifier}`;
    }
    if (facilityCity !== "") {
      params += `&city=${facilityCity}`;
    }
    if (parentOrganizations !== "") {
      params += `&parentOrg=${parentOrganizations}`;
    }
    if (facilityType.length > 0) {
      params += `&facilityType=${facilityType.toString()}`;
    }
    if (state.length > 0) {
      params += `&state=${state.toString()}`;
    }
    if (dataType.length > 0) {
      params += `&dataType=${dataType.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const handleStatesCheckboxChange = (event) => {
    let copyCheckedValues = [...statesCheckedValues];

    if (copyCheckedValues.includes(event.target.name)) {
      copyCheckedValues = copyCheckedValues.filter(
        (item) => item !== event.target.name
      );
    } else {
      copyCheckedValues = [...copyCheckedValues, event.target.name];
    }
    setStatesCheckedValues(copyCheckedValues);
    setFilterField("states", copyCheckedValues);
  };

  const getFacilitiesData = useCallback(
    async (filter) => {
      let response = await fetchFacilitiesData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );
      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          setFacilitiesData(data);
        } else {
          setIsFetchError(true);
          let error = await response.json();
          setIsError(true);
          setAlertMessage(error?.description);
        }
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const getStates = async () => {
    let response = await fetchCodeSetTable("State");
    if (response.ok) {
      let data = await response.json();
      setStates(data.refTableValues);
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  const removeFacility = async () => {
    let response = await removeFacilityRecord(selectedRow.sendingFacilityId);
    if (response !== ERROR_MSG) {
      setIsDeleted(true);
      setSelectedRow(null);
    } else {
      setIsError(true);
    }
    handleRemoveWarningModalClose();
  };

  const getFacilityDetails = async (sendingFacilityId) => {
    let response = await fetchFacilityById(sendingFacilityId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setFacilityDetails(data);
        setIsUpdated(false);
        setIsAdded(false);
        setIsDeleted(false);
        setIsError(false);
        setShowDetailsModal(true);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  useEffect(() => {
    getFacilitiesData(filter);
  }, [pageNo, recordsPerPage, getFacilitiesData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getFacilitiesData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getFacilitiesData]);

  useEffect(() => {
    if (pageNo >= facilitiesData?.totalPages) {
      facilitiesData?.totalPages !== 0 &&
        setPageNo(facilitiesData?.totalPages - 1);
    }
    // else setPageNo(0)
  }, [facilitiesData]);

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const handleAdd = () => {
    navigate("/facilityForm", {
      state: {
        filter:filter,
        pageNo:pageNo,
      },
    });
  };

  const handleShowFilter = () => {
    getStates();
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = async () => {
    navigate("/facilityForm", {
      state: {
        action: "update",
        selectedRow: selectedRow,
        filter:filter,
        pageNo:pageNo,
      },
    });
  };
  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsUpdated(false);
    setIsAdded(false);
    setIsDeleted(false);
    setIsError(false);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getFacilitiesData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setStatesCheckedValues([]);
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(SFTRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null && !isError}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isDeleted) {
      return "Successfully deleted Facility record";
    } else if (isAdded) {
      return "Successfully added new Facility!";
    } else if (isUpdated) {
      return "Successfully updated Facility!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (filter?.lab || filter?.facility) {
      active.push("0");
    }
    if (statesCheckedValues.length > 0) {
      active.push("1");
    }
    if (filter?.elr || filter?.ecr) {
      active.push("2");
    }
    if (filter?.active || filter?.inactive) {
      active.push("3");
    }
    return active;
  };

  return (
    <>
      <Container fluid className="facilitiesContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Sending Facility Table</Row>
            <Row className="tableSubtitle generalFont">
              View all the facilities available to you
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={facilitiesHeadCells}
          rows={facilitiesData?.genericList}
          pages={facilitiesData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New Sending Facility"
          addButtonAction={handleAdd}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isSendingFacilityTable={true}
          getFacilityDetails={getFacilityDetails}
          filter={filter}
          pageNo={pageNo}
        />
      </Container>

      <Modal
        show={showDetailsModal}
        onHide={handleCloseDetailsModal}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            <div className="cardBody">
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}details-icon.png`}
                style={{
                  width: "32px",
                  height: "32px",
                  marginRight: "15px",
                }}
                alt=""
              ></img>
              Sending Facility Details
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <Row>
            <Col sm={3}>
              <div className="repLoincModalTitle">Facility Name:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.sendingFacilityName)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Sending Facility ID:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.sendingFacilityIdentifier)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Facility Type:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.sendingFacilityType)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Parent Organization:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.parentOrganization)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">Facility Master ID :</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.sendingFacilityId)}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "20px" }}></hr>
          <Row style={{ marginTop: "20px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">CLIA:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.clia)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">OID:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.oid)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">NPI:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.npi)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Data Type:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.dataType)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">Date Activated:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.dateActivated)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Date Deactivated:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.dateDeactivated)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Date Planned:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.plannedDate)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Status:</div>
              <div
                className={`${
                  facilityDetails?.isActive
                    ? "activeColStyle"
                    : "inactiveColStyle"
                }`}
                style={{ width: "80px" }}
              >
                {facilityDetails?.isActive ? "Active" : "Inactive"}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row>
            <Row style={{ marginBottom: "40px" }}>
              <div className="cardBody">Address Details</div>
            </Row>
            <Col sm={6}>
              <div className="repLoincModalTitle">Street Address 1:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.addressLine1)}
              </div>
            </Col>
            <Col sm={6}>
              <div className="repLoincModalTitle">Street Address 2:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.addressLine2)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">City:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.city)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">State:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.state)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">Phone Number:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.address?.phoneNo)}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">Submission Pathway:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.submissionPathway)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">EMR:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.emr)}
              </div>
            </Col>
            <Col sm={3}>
              <div className="repLoincModalTitle">LIS:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.lis)}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "40px" }}>
            <Col sm={3}>
              <div className="repLoincModalTitle">Vendor Name:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.vendorName)}
              </div>
            </Col>
            <Col>
              <div className="repLoincModalTitle">Vendor Software:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.vendorSoftware)}
              </div>
            </Col>
          </Row>
          <hr style={{ marginTop: "40px", marginBottom: "40px" }}></hr>
          <Row style={{ marginBottom: "40px" }}>
            <Col>
              <div className="repLoincModalTitle">Admin Comments:</div>
              <div className="repLoincModalSubtitle">
                {showPopupDetails(facilityDetails?.comments)}
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Facility
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this Facility from the Table?
              <br />
              <br />
              The Facility will no longer be visible on the screen and all
              rules/conditions associated with this Facility will also be
              deleted
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeFacility}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Facility Name"
                value={filter.searchNameText ? filter.searchNameText : ""}
                onChange={(e) =>
                  setFilterField("searchNameText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br /> <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Facility ID"
                value={
                  filter.searchFacilityIdText ? filter.searchFacilityIdText : ""
                }
                onChange={(e) =>
                  setFilterField("searchFacilityIdText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br /> <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search City"
                value={filter.searchCityText ? filter.searchCityText : ""}
                onChange={(e) =>
                  setFilterField("searchCityText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br /> <br />
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Parent Organization"
                value={filter.parentOrgText ? filter.parentOrgText : ""}
                onChange={(e) =>
                  setFilterField("parentOrgText", e.target.value)
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br /> <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Facility Type</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Lab"
                      checked={filter.lab ? true : false}
                      onChange={(e) => setFilterField("lab", e.target.checked)}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Facility"
                      checked={filter.facility ? true : false}
                      onChange={(e) =>
                        setFilterField("facility", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">State</div>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    maxHeight: "200px",
                    overflow: "scroll",
                    overflowX: "hidden",
                  }}
                >
                  <FormGroup>
                    {states
                      .sort((a, b) =>
                        a.reference_Code_description >
                        b.reference_Code_description
                          ? 1
                          : -1
                      )
                      .map((item) => {
                        return (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={statesCheckedValues.includes(
                                  item?.reference_Code_description
                                )}
                                onChange={handleStatesCheckboxChange}
                                name={item?.reference_Code_description}
                              />
                            }
                            label={item?.reference_Code_description}
                          />
                        );
                      })}
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <div className="bold">Data Type</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="ELR"
                      checked={filter.elr ? true : false}
                      onChange={(e) => setFilterField("elr", e.target.checked)}
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="ECR"
                      checked={filter.ecr ? true : false}
                      onChange={(e) => setFilterField("ecr", e.target.checked)}
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Facilities;
